import { useEffect } from 'react';
import { useInstallGitlabWebhooksMutation } from 'network/mutations/useInstallGitlabWebhooksMutation';
import { InstallationStatusMessage, Step } from 'shared/InstallationDialog';
import { useMultiStepDialog } from 'shared/MultiStepDialog';
import { spawn } from 'utils/translations';
import { useGitlabInstallation } from '../gitlabInstallationContext';

export const CheckConnection = () => {
  const spawnStep = spawn('dialogs.gitlab-installation.check-connection');

  const { currentStepIndex, setEarliestStepAvailable, setIsNextEnabled } =
    useMultiStepDialog();

  const {
    appConfigId,
    webhookResult,
    setWebhookResult,
    totalSucceededCount,
    setTotalSucceededCount,
  } = useGitlabInstallation();

  const webhookMutation = useInstallGitlabWebhooksMutation();

  const failedProjects = webhookResult?.failed ?? [];
  const hasFailures = failedProjects.length > 0;

  useEffect(() => {
    setEarliestStepAvailable(currentStepIndex);
    setIsNextEnabled(totalSucceededCount > 0);
  }, [totalSucceededCount]);

  const onRetry = () => {
    if (!appConfigId) return;

    const failedProjectIds = failedProjects.map((p) => p.projectId);

    webhookMutation.mutate(
      { appConfigId, projectIds: failedProjectIds },
      {
        onSuccess: (result) => {
          setTotalSucceededCount(totalSucceededCount + result.succeeded.length);
          setWebhookResult(result);
        },
      },
    );
  };

  const renderStatus = () => {
    if (hasFailures) {
      const detailText = failedProjects
        .map((p) =>
          p.error ? `${p.projectId} - ${p.error}` : `${p.projectId}`,
        )
        .join(', ');

      return (
        <InstallationStatusMessage
          status="error"
          message={spawnStep('error')}
          detail={detailText}
          retryLabel={spawnStep('test-connection-button')}
          onRetry={onRetry}
          isRetrying={webhookMutation.isPending}
        />
      );
    }

    return (
      <InstallationStatusMessage
        status="success"
        message={spawnStep('success')}
      />
    );
  };

  return (
    <Step>
      <div className="flex flex-col gap-4">{renderStatus()}</div>
    </Step>
  );
};
